import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import EventListWithSearch from './EventListWithSearch';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	handleShowEventInCalendar: (eventId: string) => void;
}

const EventListWithSearchModal: React.FC<Props> = props => (
	<BaseModal
		{...props}
		title='component.eventListWithSearchModal.title'
		size={Size.FULLSCREEN}>
		<EventListWithSearch
			handleShowEventInCalendar={props.handleShowEventInCalendar}
		/>
	</BaseModal>
);

export default EventListWithSearchModal;
